<template>
  <v-list class="mt-3 mb-5">
    <!-- Events & Moments & Friends Events -->
   
    <v-list-tile class="my-1">
      <v-switch
        v-model="displayActivity"
        class="ml-3"
        label="Events"
        color="pink lighten-1"
        value="events"
        hide-details>
      </v-switch>
      <v-list-tile-action>
        <v-icon 
          large
          color="pink lighten-1">
          fas fa-star
        </v-icon>
      </v-list-tile-action>
    </v-list-tile>
    <v-list-tile
      class="my-1">
      <v-switch
        v-model="displayActivity"
        class="ml-3"
        label="Events by Friends (noch nicht verfügbar)"
        color="orange"
        value="eventsbyfriends"
        hide-details>
        <span
          slot="label"
          class="font-italic"><span>Events by Friends </span>
          <!-- TODO -->
          <small>(Funktion noch nicht verfügbar)</small>
        </span>
      </v-switch>
      <v-list-tile-action>
        <v-icon 
          x-large 
          color="orange">
          fas fa-stars
        </v-icon>
      </v-list-tile-action>
    </v-list-tile>
   

    <v-list-tile class="my-1">
      <v-switch
        v-model="displayActivity"
        class="ml-3"

        label="Moments"
        color="amber lighten-2"
        value="moments"
        hide-details>
      </v-switch>
      <v-list-tile-action>
        <v-icon
          icon-color="#FFD54F"
          height="40"
          width="40">
          $vuetify.icons.chartbubble
        </v-icon>
      </v-list-tile-action>
    </v-list-tile>


    
   

    <v-list-tile class="my-1">
      <!-- <v-list-tile-action></v-list-tile-action> -->

      <!-- {{ displayActivity }} -->
      <v-subheader>{{ warning }}</v-subheader>
    </v-list-tile>
    
    <v-layout class="text-xs-center pa-4">
      <v-flex xs12>
        <!-- TODO: Text/Translate -->

        <article class="font-italic primary--text">
          <p>Wähle aus was du angezeigt bekommen willst!</p>
          <p>
            Events, Events by Friends oder Moments ...
          </p>
        </article>
      </v-flex>
    </v-layout>
  </v-list>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      warning: null
    }
  },
  computed: {
    ...mapState({
      timelineFilter: state => state.timeline.timelineFilter,
      user: state => state.user.user,
      isMobile: state => state.isMobile,
    }),
    displayActivity: {
      get() {
        return this.timelineFilter.activityFilter
      },
      set(value) {
        this.setFilter({ activityFilter: value })
      }
    }
  },
  watch: {
    displayActivity() {
      if (this.displayActivity.length < 1) {
        this.displayActivity = [
          'events'
        ]
        // <!-- TODO: Text/Translate -->

        this.warning = 'Mindestens eine Activity muss aktiv sein!'
      }
    }
  },
  methods: {
    ...mapMutations([
      'setFilter',
    ]),
  },
}
</script>
